/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-01T14:27:19.627
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-renttag-'

export default 
{
path: '/rentmanage/renttag',
name: 'rentmanage-renttag',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}renttag-index',

meta:{
...meta,
title: '标签表'
},

component: () => import('@/pages/rentmanage/renttag/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}renttag-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '标签表编辑'
},

component: () => import('@/pages/rentmanage/renttag/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}renttagdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '标签表新增'
},

component: () => import('@/pages/rentmanage/renttag/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}renttagView',
auth: [
'hidden'
],

meta:{
...meta,
title: '标签表详情查看'
},

component: () => import('@/pages/rentmanage/renttag/detail-view') ,
},
]
};
